"use client"

import useSWR from "swr"

import { fetchGameSuggestions } from "@/client-api/casino/suggestions"
import type { LobbySuggestion } from "@/domain/casino/listing/types"

type GameSuggestionsState = {
  suggestions: LobbySuggestion[]
  isLoading: boolean
  isError: boolean
}

export function useGameSuggestions(query: string): GameSuggestionsState {
  const trimmed = query.trim()
  const key =
    trimmed.length >= 2 ? (["casino/game-suggestions", trimmed] as const) : null

  const { data, error, isLoading } = useSWR(
    key,
    ([, search]) => fetchGameSuggestions(search),
    {
      revalidateOnFocus: false,
      keepPreviousData: false
    }
  )

  const pending = key !== null && data === undefined && !error

  return {
    suggestions: data?.suggestions ?? [],
    isLoading: isLoading || pending,
    isError: Boolean(error)
  }
}
